import { render } from "./ExampleDeviceScreenTwitter.vue?vue&type=template&id=28aa0be2&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenTwitter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenTwitter.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenTwitter.vue?vue&type=style&index=0&id=28aa0be2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28aa0be2"]])

export default __exports__